var _path, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCardAttachment(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 12,
    viewBox: "0 0 9 9",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1419_48194",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 9,
    height: 9
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.14 0H0V8.14H8.14V0Z",
    fill: "#868686"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1419_48194)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.7322 7.0233H2.28898C2.06464 7.0233 1.88281 6.84144 1.88281 6.6171C1.88281 6.39277 2.06464 6.21094 2.28898 6.21094H7.732C7.9564 6.21094 8.1382 6.39277 8.1382 6.6171C8.1382 6.84144 7.9565 7.0233 7.7322 7.0233Z",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.7322 4.4764H2.28898C2.06464 4.4764 1.88281 4.29457 1.88281 4.07023C1.88281 3.84589 2.06464 3.66406 2.28898 3.66406H7.732C7.9564 3.66406 8.1382 3.84589 8.1382 4.07023C8.1383 4.29457 7.9565 4.4764 7.7322 4.4764Z",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.7322 1.92952H2.28898C2.06464 1.92952 1.88281 1.74769 1.88281 1.52335C1.88281 1.29902 2.06464 1.11719 2.28898 1.11719H7.732C7.9564 1.11719 8.1382 1.29902 8.1382 1.52335C8.1382 1.74769 7.9565 1.92952 7.7322 1.92952Z",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.54548 2.09878C0.84674 2.09878 1.09097 1.85456 1.09097 1.5533C1.09097 1.25203 0.84674 1.00781 0.54548 1.00781C0.24422 1.00781 0 1.25203 0 1.5533C0 1.85456 0.24422 2.09878 0.54548 2.09878Z",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.54548 4.6144C0.84674 4.6144 1.09097 4.37018 1.09097 4.06892C1.09097 3.76766 0.84674 3.52344 0.54548 3.52344C0.24422 3.52344 0 3.76766 0 4.06892C0 4.37018 0.24422 4.6144 0.54548 4.6144Z",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.54548 7.1378C0.84674 7.1378 1.09097 6.89361 1.09097 6.59235C1.09097 6.29109 0.84674 6.04688 0.54548 6.04688C0.24422 6.04688 0 6.29109 0 6.59235C0 6.89361 0.24422 7.1378 0.54548 7.1378Z",
    fill: "#868686"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCardAttachment);
export default __webpack_public_path__ + "static/media/CardAttachment.6fbfe689e066df964c2f953c4621f36c.svg";
export { ForwardRef as ReactComponent };